export const REPORT_ID = 'slide-31';
export const SLIDE_NUMBER = 31;